<template>
    <div class="main_wrap">
        <NavTab />

        <div class="form_case">
            <el-form ref="my_form" class="my_form" inline :model="model" label-width="80px" size="small">
                <el-form-item label="所属单位" prop="firstOrganizationId">
                    <el-select v-model="model.firstOrganizationId" clearable placeholder="请选择支队" @change="onSelectZhidui">
                        <el-option v-for="item in zhiduiLists" :label="item.fullName" :key="item.id" :value="item.id" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="secondOrganizationId">
                    <el-select v-model="model.secondOrganizationId" clearable placeholder="请选择大队">
                        <el-option v-for="item in daduiLists" :label="item.fullName" :key="item.id" :value="item.id" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                    <el-select v-model="model.type" placeholder="请选择">
                        <el-option v-for="item in caseTypeLists" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预约时间">
                    <el-date-picker
                        start-placeholder="开始时间"
                        range-separator="至"
                        end-placeholder="结束时间"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        v-model="timeValue"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button class="my_btn" type="primary" @click="fetchData">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button class="my_btn" type="primary" @click="onExport">导出</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table_wrap">
            <div class="my_table">
                <el-table style="width: 100%;" :data="tableData" border :header-cell-style="tableHeaderStyle" :cell-style="tableCellStyle" show-summary :summary-method="getSummaries" >
                    <!-- <el-table-column width="55" align="center" type="index" label="序号"></el-table-column> -->
                    <el-table-column min-width="200px" align="center" label="所属单位" prop="firstOrganizationName"></el-table-column>
                    <el-table-column min-width="250px" align="center" label="所属单位" prop="secondOrganizationName"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="类型">
                        <template slot-scope="scope">{{scope.row.type == null || scope.row.type == "" ? "" : scope.row.type == 2 ? "一般程序" : "简易程序"}}</template>
                    </el-table-column>
                    <el-table-column min-width="100px" align="center" label="总量数" prop="allNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="小程序新建" prop="initedNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="PC端新建" prop="pcInitedNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="暂存" prop="savedNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="全流程完成" prop="finishedNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="处置终止" prop="stoppedNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="手动取消" prop="cancelledNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="超时取消" prop="timeoutCancelledNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="接警人超时取消" prop="policeTimeoutCancelledNum"></el-table-column>
                    <el-table-column min-width="100px" align="center" label="当事人超时取消" prop="reporterTimeoutCancelledNum"></el-table-column>
                </el-table>
            </div>

        </div>
    </div>
</template>

<script>
    import NavTab from "@/components/navTab.vue" 

    export default {
        name: "Count",
        components: {
            NavTab,
        },
        data() {
            return {
                model: {
                    firstOrganizationId: null,
                    secondOrganizationId: null,
                    type: null,
                    startTime: null,
                    endTime: null,
                },
                zhiduiLists: [],
                daduiLists: [],
                caseTypeLists: [
                    {value: null, label: "全部"},
                    {value: 1, label: "简易程序"},
                    {value: 2, label: "一般程序"},
                ],
                timeValue: [],
                tableData: [],
                footData: null,


            }
        },
        created() {
            this.getZhiduiLists();
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            // 获取支队列表
			getZhiduiLists() {
				this.$axios.get(`/admin/organization/childrenList/parent-1`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if(code == 0) {
						this.zhiduiLists = data;
					}
				})
			},
            // 获取大队列表
			getDaduiLists(id) {
				this.$axios.get(`/admin/organization/childrenList/parent-${id}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if(code == 0) {
						this.daduiLists = data;
					}
				})
			},
            onSelectZhidui(e) {
                console.log(e)
                this.getDaduiLists(e);
            },

            fetchData() {
                console.log(this.timeValue)
                if(this.timeValue) {
                    this.model.startTime = this.timeValue[0];
                    this.model.endTime = this.timeValue[1];
                } else {
                    this.model.startTime = null;
                    this.model.endTime = null;
                }
                this.tableData = [];
                this.footData = null;
                this.$axios.post(`/admin/appointment/statistic`, this.model).then(res => {
                    let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
                    if(code == 0) {
                        this.tableData = data.list;
                        this.footData = data;
                        this.footData.firstOrganizationName = "合计";
                    }
                })
            },

            getSummaries(param) {
                // console.log(param)
                const { columns, data } = param;
                const sums = [];
                columns.forEach((item, index) => {
                    if (this.footData) {
                        sums.push(this.footData[item.property]);
                        // return;
                    }
                })
                return sums;
            },

            onExport() {
                if (this.tableData.length < 1)  return this.$message.error("暂无可导出数据");

                this.$axios.post(`/admin/appointment/export/statistic`, this.model, {
                    responseType: "arraybuffer"
                }).then(res => {
                    let fileName = "统计管理.xls";
                    let blob = new Blob([res.data], {
                        type: "application/x-xls"
                    })
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                })

            },


            tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
				if(rowIndex === 0) {
					return "height:50px; font-size:14px; background:#f4f5f7; color:#4a4a4a!important;";
				}
			},
            tableCellStyle({ row, column, rowIndex, columnIndex }) {
				return "font-size:13px;";
			},


        }
    }
</script>

<style lang="scss" scoped>
    .form_case {
        width: 100%;
        padding: 20px 0;
        background: #fff;
    }
    .my_form {
        width: 100%;
        display: flex;
        flex-flow: wrap;
    }
    .my_btn {
        margin-left: 20px;
    }
    .my_table {
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// count.vue?7d2619d1